module.exports = __webpack_public_path__ + "static/media/alert.c9eef1b7.svg";